// seconds to substract when setting the access token cookie lifetime
export const ACCESS_TOKEN_COOKIE_EXPIRY_TRESHOLD = 120;
// seconds to substract from the access token expiry saved in the auth state cookie,
// used in the browser to refresh the access token in time
export const AUTH_STATE_EXPIRY_TRESHOLD =
  ACCESS_TOKEN_COOKIE_EXPIRY_TRESHOLD + 180;
